import { InvoiceProcessing } from "../InvoiceProcessing";
import { DataSource, Layout, Tab, Tabset } from "@mcleod/components";

export abstract class AutogenLayoutInvoiceProcessingMultiProfile extends Layout {
    layoutInvoiceProcessing: InvoiceProcessing;
    sourceInvoiceProcessingCache: DataSource;
    sourceInvoiceProcessingProfile: DataSource;
    tabProfile: Tab;
    tabsetInvoiceProcessingProfiles: Tabset;
}
